import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export const FaqList = ({ items, prefix }) => (
  <Accordion type="multiple" className="border-b border-ink/30" data-testid={`${prefix}-faq-list`}>
    {items.map((f, i) => (
      <AccordionItem key={f.q} value={`q${i}`} className="border-t border-ink/30 border-b-0">
        <AccordionTrigger className="font-display text-xl text-left font-normal py-5 hover:no-underline hover:text-teal" data-testid={`${prefix}-faq-trigger-${i}`}>
          {f.q}
        </AccordionTrigger>
        <AccordionContent className="text-[17px] text-ink pb-5">{f.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
